<section class="home-trust-carousel" aria-label="Marcas que confían en nosotros">
  <div class="container-fluid px-0">
    <div class="trust-carousel-shell">
      <div class="trust-carousel-label section-head reveal-on-scroll" data-reveal="section-head">
        <span>Marcas que <span class="highlight-green">confían en nosotros</span></span>
      </div>
      <div class="trust-carousel-viewport">
        <button type="button" class="trust-control-btn trust-control-prev" aria-label="Logo anterior" #prevBtn>
          <i class="bi bi-chevron-left"></i>
        </button>

        <div class="trust-carousel-stage">
          <swiper-container init="false" #logoSwiper class="trust-swiper">
            @for (logo of clientLogos; track logo.file) {
            <swiper-slide>
              <div class="trust-logo-item">
                <img class="img-fluid" [src]="'assets/brand/clients/' + logo.file" [alt]="logo.name" loading="lazy" />
              </div>
            </swiper-slide>
            }
          </swiper-container>
        </div>

        <button type="button" class="trust-control-btn trust-control-next" aria-label="Siguiente logo" #nextBtn>
          <i class="bi bi-chevron-right"></i>
        </button>
      </div>
    </div>
  </div>
</section>
